// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/mf-reporting-requirements.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/mf-reporting-requirements/mf-reporting-requirements.js';

mount([g0]);
